// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1512":"83066af7","2051":"781729ed","6190":"b8bf295e","8438":"6ea18e30"}[chunkId] + ".chunk.css";
};